import ThemedImage from './ThemedImage';

export { ThemedImage };
